import comp from '../components/barrel';

export default {
  async prepare() {


    const {value} = await O.getCookie('ewttgpvwwkf');
    this.target_user_uuid = value;
    this.recipe.methods.push(await O.mGET(`myProfile/profile/${value}`));
    this.recipe.methods.push(await O.mPOST('communal/languages'));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(res) {
    const {value} = await O.getCookie('ewttgpvwwkf');
    const data = await res[`myProfile/profile/${value}`].data[0];
    const dataLangDD = await res[`communal/languages`].data;

    // FORM ==========
    const form = U.id('profile-form');
    form.innerHTML = '';
    U.id('user-name-header').innerHTML = `${data.f_name} ${data.s_name}`;

    // Name
    let nameText = comp.displayText('f_name', data.f_name, 'First names');
    form.appendChild(nameText);
    // Surname
    let sNameText = comp.displayText('s_name', data.s_name, 'Surname');
    form.appendChild(sNameText);
    // Email
    let emailText = comp.displayText('email_address', data.email_address, 'Email');
    form.appendChild(emailText);
    // Mobile
    let mobInput = await comp.inputTel('cell_nr', data.cell_nr, 'Mobile number', 1);
    form.appendChild(mobInput);
    // Language DropDown
    const langDD = await comp.select_v2({elID: 'language_id', ddData: dataLangDD, valueDataName: 'language_uuid', textDataName: 'long_text', labelName: 'Language', requiredYN: 1, initValue: data.language_uuid});
    form.appendChild(langDD);
    // Password
    // let inputPass = await comp.inputPassword('password_fake', 0, );
    let inputPass = await comp.inputPassword({elID: 'password_fake_profile', onclick: 'thsPage.updatePassword()'});
    form.appendChild(inputPass);
  },

  async updateProfile() {
    if (!(await U.validateForm('profile-form'))) {
      return;
    }

    const vars = {};
    vars.cell_nr = U.id('cell_nr').value;
    vars.language_uuid = U.id('language_id').value;
    vars.target_user_uuid = this.target_user_uuid;

    O.PREP([await O.mPOST('myProfile/profile', vars)])
      .then(async (res) => {
        const msg = res['myProfile/profile'].status;
        comp.toast(msg);
        this.render();
      })
      .catch((err) => {
      });
  },

  async updatePassword() {
    const newPassword1 = U.id('newPassword1').value;
    const newPassword2 = U.id('newPassword2').value;

    // Min 8 char, 1 upper, 1 lower, one special
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

    if (newPassword1 === newPassword2) {
      if (!regex.test(newPassword1)) {
        return comp.toast_v2({msg: 'Please choose a stronger password', state: 2});
      }

      const vars = {};
      vars.userpass = U.id('newPassword1').value;

      O.PREP([await O.mPOST('myProfile/password', vars)])
        .then(async (res) => {
          const msg = res['myProfile/password'].status;
          comp.toast(msg);
          U.closeModal('passBox');
        })
        .catch(() => {
        });
    } else {
      comp.toast_v2({msg: 'Passwords are not the same.', state: 2});
    }
  },
};
